import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';

import {
  WS_UPDATE_CRM_STATUS,
  REFETCH_MANAGER_STATUSES,
  SET_WS_CURRENT_MANAGER_TICKETS_COUNT,
} from '../../actions/general';

import { CRM_STATES } from '../../../consts/general';

class ManagerStatusChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  public create(message: ISocketMessage): void {
    return undefined;
  }

  public update(message: ISocketMessage): void {
    const {
      id: operatorId,
      status_id: operatorState,
      active_tickets_count: activeTicketsCount,
      reserved_tickets_count: reservedTicketsCount,
      update_statuses_list: shouldFetchManagerStatuses,
    } = message.data;

    if (activeTicketsCount !== undefined) {
      this.socketChannel.put({
        type: SET_WS_CURRENT_MANAGER_TICKETS_COUNT,
        payload: {
          operatorId,
          activeTicketsCount,
          reservedTicketsCount,
        },
      });
    }

    if (shouldFetchManagerStatuses) {
      this.socketChannel.put({
        type: REFETCH_MANAGER_STATUSES,
      });
    }

    if (operatorState) {
      this.socketChannel.put({
        type: WS_UPDATE_CRM_STATUS,
        payload: {
          operatorId,
          operatorState: Number(operatorState || CRM_STATES.OFFLINE),
        },
      });
    }
  }

  public delete(): void {
    return undefined;
  }

  public info(): void {
    return undefined;
  }
}

export default ManagerStatusChannelHandler;
